<div class="head-wrapper">
  <div class="head-title">瑞海热控指挥能源云实时数据看板</div>
</div>
